import React from "react";

const DocumentNumbering = ({
  onClickFn = () => {},
  width = "21",
  height = "21",
  fill = "currentColor",
}) => {
  return (
    <svg
      className="cursor-pointer"
      onClick={onClickFn}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M24 24H0V0H24V24Z" stroke="#E5E7EB"/>
<path d="M1.12499 2.625C1.12499 2.00156 1.62655 1.5 2.24999 1.5H3.74999C4.37343 1.5 4.87499 2.00156 4.87499 2.625V8.25H5.62499C6.24843 8.25 6.74999 8.75156 6.74999 9.375C6.74999 9.99844 6.24843 10.5 5.62499 10.5H1.87499C1.25155 10.5 0.749992 9.99844 0.749992 9.375C0.749992 8.75156 1.25155 8.25 1.87499 8.25H2.62499V3.75H2.24999C1.62655 3.75 1.12499 3.24844 1.12499 2.625ZM4.06405 15.9938C3.75937 15.6469 3.20624 15.6703 2.93905 16.05L2.41405 16.7766C2.05312 17.2828 1.34999 17.4 0.843742 17.0391C0.337492 16.6781 0.220304 15.975 0.581242 15.4688L1.10155 14.7375C2.21249 13.1812 4.49062 13.0688 5.75155 14.5078C6.74999 15.6516 6.72655 17.3625 5.69999 18.4781L4.06874 20.25H5.62499C6.24843 20.25 6.74999 20.7516 6.74999 21.375C6.74999 21.9984 6.24843 22.5 5.62499 22.5H1.49999C1.05468 22.5 0.646867 22.2375 0.468742 21.825C0.290617 21.4125 0.370304 20.9391 0.670304 20.6109L4.0453 16.9547C4.29374 16.6828 4.29843 16.2703 4.05937 15.9938H4.06405ZM10.5 3H22.5C23.3297 3 24 3.67031 24 4.5C24 5.32969 23.3297 6 22.5 6H10.5C9.6703 6 8.99999 5.32969 8.99999 4.5C8.99999 3.67031 9.6703 3 10.5 3ZM10.5 10.5H22.5C23.3297 10.5 24 11.1703 24 12C24 12.8297 23.3297 13.5 22.5 13.5H10.5C9.6703 13.5 8.99999 12.8297 8.99999 12C8.99999 11.1703 9.6703 10.5 10.5 10.5ZM10.5 18H22.5C23.3297 18 24 18.6703 24 19.5C24 20.3297 23.3297 21 22.5 21H10.5C9.6703 21 8.99999 20.3297 8.99999 19.5C8.99999 18.6703 9.6703 18 10.5 18Z" fill={fill}/>
    </svg>
  );
};

export default DocumentNumbering;